import { action, makeObservable, observable, computed } from "mobx"
import { BaseColumn } from "./BaseColumn"
import { get } from 'lodash'

const mobxReg = /^mobx:\/\//
export class HeaderColumns {
  baseColumn: BaseColumn
  _visible: boolean | undefined
  _required: boolean | undefined
  _disabled: boolean | undefined
  _readOnly: boolean | undefined
  visible: boolean | undefined
  required: boolean | undefined
  disabled: boolean | undefined
  readOnly: boolean | undefined

  constructor(tableHeader: any, baseColumn: BaseColumn) {
    this.baseColumn = baseColumn
    this.visible = tableHeader?.visible
    this.required = tableHeader?.required
    this.disabled = tableHeader?.disabled
    this.readOnly = tableHeader?.readOnly
    this._visible = undefined
    this._required = undefined
    this._disabled = undefined
    this._readOnly = undefined
    makeObservable(this, {
      _visible: observable,
      _required: observable,
      _disabled: observable,
      _readOnly: observable,
      setVisible: action,
      setDisabled: action,
      setRequired: action,
      setReadOnly: action,
      flowFieldAuth: computed
    })
  }

  setVisible(visible: boolean) {
    this._visible = visible
  }
  setRequired(required: boolean) {
    this._required = required
  }
  setDisabled(disabled: boolean) {
    this._disabled = disabled
  }
  setReadOnly(readOnly: boolean) {
    this._readOnly = readOnly;
  }
  /**
   *检查规则是否有协议控制，如果有优先使用this.visible 为协议字段。
   *
   * @readonly
   * @memberof HerderColumns
   */
  get isVisible() {
    const vis = this.visible !== undefined ? this.getMobxProperty(this.visible) : this._visible
    if (vis === undefined) return this.flowFieldAuth?.visible
    return vis
  }
  /**
   *检查规则是否有协议控制，如果有优先使用this.required 为协议字段。
   *
   * @readonly
   * @memberof HerderColumns
   */
  get isRequired() {
    return this.required !== undefined ? this.getMobxProperty(this.required) : this._required
  }

  get isDisabled() {
    const dis = this.disabled !== undefined ? this.getMobxProperty(this.disabled) : this._disabled
    if (dis === undefined && this.flowFieldAuth !== undefined) return !this.flowFieldAuth.editable
    return dis
  }

  get isReadOnly() {
    return this.readOnly !== undefined ? this.getMobxProperty(this.readOnly) : this._readOnly
  }

  getMobxProperty = (property: any) => {
    // @ts-ignore
    const rootStore = this.baseColumn.tableStore.rootStore
    if (typeof property === "string" && mobxReg.test(property)) {
      try {
        return eval(property.replace(mobxReg, ''));
      } catch (error) {
        console.log("error", error);
      }
    } 
    return property 
    // return typeof (property) === 'string' && mobxReg.test(property)
    //   ? eval(property.replace(mobxReg, ''))
    //   : property
  }

  get flowFieldAuth() {
    const field = this.baseColumn.getField()
    if (!field) return
    const formStoreKey = this.baseColumn.tableStore.formStoreKey
    const dataSource = this.baseColumn.tableStore.dataSource
    if (!formStoreKey || !dataSource) return
    const formStore = this.baseColumn.tableStore.rootStore[formStoreKey]
    
    // 没有流程实例id，或者驳回到制单的状态，或者没有配置过流程字段权限，就不用管字段权限
    if (!formStore.procinstId || formStore.verifyState == 4 || !formStore.workFlowStore.currentTaskAuth) return

    const defaultAuth = { visible: true, editable: false }
    // 特征字段，field字段为空，暂时先用fieldAlias，后续会改成field
    if (this.baseColumn.isCharacter()) {
      return get(formStore.workFlowStore.currentTaskAuth[dataSource], field) || defaultAuth
    }
    return formStore.workFlowStore.currentTaskAuth[dataSource]?.[field] || defaultAuth
  }
}
